import { Image as ImageIcon } from 'lucide-react';
import { useSupport } from '../../../../../../../context/support/SupportContext';

const VisualEvidencePicker = () => {
  const { screenshotPreview, handleScreenshotChange, isSubmitting } = useSupport();

  return (
    <div className="space-y-1">
      <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5 ml-1">
        Visual Evidence
      </label>
      <label
        className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-200 rounded-2xl transition-all overflow-hidden group bg-gray-50/50 ${
          isSubmitting ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:bg-gray-50'
        }`}
      >
        {screenshotPreview ? (
          <img
            src={screenshotPreview}
            className="h-full w-full object-contain p-2"
            alt="Preview"
          />
        ) : (
          <div className="flex flex-col items-center justify-center py-5">
            <ImageIcon className="text-gray-300 group-hover:text-[#067978] mb-2" size={24} />
            <p className="text-xs text-gray-400 font-medium tracking-tight">
              Capture Image
            </p>
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleScreenshotChange}
          disabled={isSubmitting}
        />
      </label>
    </div>
  );
};

export default VisualEvidencePicker;
